/**
 * Returns true when the channel has activity newer than the user's
 * last read. Used as the dot/badge fallback when an exact count isn't
 * available (e.g. messages that landed while the WS was offline).
 */
export function isChannelUnread(
  lastMessageAt: string | undefined,
  lastReadAt: string | undefined,
): boolean {
  if (!lastMessageAt) return false;
  if (!lastReadAt) return true;
  return lastMessageAt > lastReadAt;
}
